import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
  Collapse,
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import RateReviewIcon from "@mui/icons-material/RateReview";
import SummarizeTwoToneIcon from "@mui/icons-material/SummarizeTwoTone";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { SIDEBAR_WIDTH } from "../constants";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { memo, PropsWithoutRef, useEffect, useRef, useState } from "react";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SettingsIcon from "@mui/icons-material/Settings";
import DescriptionIcon from "@mui/icons-material/Description";
import CategoryIcon from "@mui/icons-material/Category";
import WidgetsIcon from "@mui/icons-material/Widgets";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import PostAddIcon from "@mui/icons-material/PostAdd";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import ChatIcon from "@mui/icons-material/Chat";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import {
  getAgentCount,
  getCompanyCount,
  getCompanyRequestCount,
  getPropertyRequestCount,
} from "../reducers/generalSlice";
import { useAppSelector } from "../hooks/store";
import useTranslation from "../hooks/Translation";
interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

function Sidebar({ mobileOpen, handleSidebarToggle }: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();
  const t = useTranslation();
  const selectedRef = useRef<HTMLDivElement | null>(null);
  const [isSelected, setIsSelected] = useState("");

  const [openMenu1, setOpenMenu1] = useState<boolean>(false);
  const [openMenu2, setOpenMenu2] = useState<boolean>(false);
  const [openMenu3, setOpenMenu3] = useState<boolean>(false);

  const agentCount = useAppSelector(getAgentCount);
  const companyCount = useAppSelector(getCompanyCount);
  const companyRequestCount = useAppSelector(getCompanyRequestCount);
  const propertyRequestCount = useAppSelector(getPropertyRequestCount);

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <figure className="logo_cntnr" onClick={() => navigate("/dashboard")}>
          <img src="/static/images/logo_white.png" alt="" />
        </figure>
        <IconButton
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "white",
            display: { lg: "none" },
          }}
          onClick={handleSidebarToggle}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        {/* Dashboard */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/dashboard"}
          onClick={() => navigate("/dashboard")}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary={t.sideBar.dashboard} />
        </ListItemButton>

        {/* Registration */}
        <ListItemButton
          className="lst-itm"
          onClick={() => {
            if (
              location.pathname === "/manage-users" ||
              location.pathname.startsWith("/manage-users/details") ||
              location.pathname.startsWith("/manage-users/edit") ||
              location.pathname.startsWith("/manage-users/usersform") ||
              location.pathname.startsWith("/manage-users/token/details") ||
              location.pathname.startsWith("/manage-users/property/details") ||
              location.pathname === "/manage-vendors" ||
              location.pathname.startsWith("/manage-vendors/details") ||
              location.pathname.startsWith("/manage-reels/agents") ||
              location.pathname.startsWith("/manage-vendors/edit") ||
              location.pathname.startsWith("/manage-vendors/add") ||
              location.pathname.startsWith("/manage-vendors/edit/chat") ||
              location.pathname.startsWith("/manage-agent/token/details") ||
              location.pathname.startsWith(
                "/manage-vendors/property/details"
              ) ||
              location.pathname.startsWith(
                "/manage-vendors/property-listing/details"
              ) ||
              location.pathname === "/manage-company-requests" ||
              location.pathname.startsWith(
                "/manage-company-requests/details"
              ) ||
              location.pathname === "/manage-company" ||
              location.pathname.startsWith("/manage-reels/company") ||
              location.pathname.startsWith("/manage-company/details") ||
              location.pathname.startsWith("/manage-company/edit") ||
              location.pathname.startsWith("/manage-company/add") ||
              location.pathname.startsWith("/manage-company/edit/chat") ||
              location.pathname.startsWith(
                "/company/property-listing/details"
              ) ||
              location.pathname.startsWith(
                "manage-users/property/details/ChatInbox"
              )
            ) {
              return;
            }

            setOpenMenu1(!openMenu1);
          }}
          selected={
            location.pathname === "/manage-users" ||
            location.pathname.startsWith("/manage-users/details") ||
            location.pathname.startsWith("/manage-users/edit") ||
            location.pathname.startsWith("/manage-users/usersform") ||
            location.pathname.startsWith("/manage-users/token/details") ||
            location.pathname.startsWith("/manage-users/property/details") ||
            location.pathname === "/manage-vendors" ||
            location.pathname.startsWith("/manage-vendors/details") ||
            location.pathname.startsWith("/manage-reels/agents") ||
            location.pathname.startsWith("/manage-vendors/edit") ||
            location.pathname.startsWith("/manage-vendors/add") ||
            location.pathname.startsWith("/manage-vendors/edit/chat") ||
            location.pathname.startsWith("/manage-agent/token/details") ||
            location.pathname.startsWith("/manage-vendors/property/details") ||
            location.pathname.startsWith(
              "/manage-vendors/property-listing/details"
            ) ||
            location.pathname === "/manage-company-requests" ||
            location.pathname.startsWith("/manage-company-requests/details") ||
            location.pathname === "/manage-company" ||
            location.pathname.startsWith("/manage-reels/company") ||
            location.pathname.startsWith("/manage-company/details") ||
            location.pathname.startsWith("/manage-company/edit") ||
            location.pathname.startsWith("/manage-company/add") ||
            location.pathname.startsWith("/manage-company/edit/chat") ||
            location.pathname.startsWith("/company/property-listing/details") ||
            location.pathname.startsWith(
              "manage-users/property/details/ChatInbox"
            )
          }
        >
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.registration}
          />
          {openMenu1 ? <ExpandLess /> : <ExpandMore />}
          {companyRequestCount || agentCount || companyCount ? (
            <span className="empty_badge" />
          ) : null}
        </ListItemButton>

        <Collapse
          in={
            openMenu1 ||
            location.pathname === "/manage-users" ||
            location.pathname.startsWith("/manage-users/details") ||
            location.pathname.startsWith("/manage-users/edit") ||
            location.pathname.startsWith("/manage-users/usersform") ||
            location.pathname.startsWith("/manage-users/token/details") ||
            location.pathname.startsWith("/manage-users/property/details") ||
            location.pathname === "/manage-vendors" ||
            location.pathname.startsWith("/manage-vendors/details") ||
            location.pathname.startsWith("/manage-reels/agents") ||
            location.pathname.startsWith("/manage-vendors/edit") ||
            location.pathname.startsWith("/manage-vendors/add") ||
            location.pathname.startsWith("/manage-vendors/edit/chat") ||
            location.pathname.startsWith("/manage-agent/token/details") ||
            location.pathname.startsWith("/manage-vendors/property/details") ||
            location.pathname.startsWith(
              "/manage-vendors/property-listing/details"
            ) ||
            location.pathname === "/manage-company-requests" ||
            location.pathname.startsWith("/manage-company-requests/details") ||
            location.pathname === "/manage-company" ||
            location.pathname.startsWith("/manage-reels/company") ||
            location.pathname.startsWith("/manage-company/details") ||
            location.pathname.startsWith("/manage-company/edit") ||
            location.pathname.startsWith("/manage-company/add") ||
            location.pathname.startsWith("/manage-company/edit/chat") ||
            location.pathname.startsWith("/company/property-listing/details") ||
            location.pathname.startsWith(
              "manage-users/property/details/ChatInbox"
            )
          }
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {/* Manage Users */}
            <ListItemButton
              className="lst-itm"
              selected={
                location.pathname === "/manage-users" ||
                location.pathname.startsWith("/manage-users/details") ||
                location.pathname.startsWith("/manage-users/edit") ||
                location.pathname.startsWith("/manage-users/usersform") ||
                location.pathname.startsWith("/manage-users/token/details") ||
                location.pathname.startsWith("/manage-users/property/details")
              }
              onClick={() => {
                navigate("/manage-users");
                setOpenMenu1(true);
              }}
            >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText
                className="lstitm-txt"
                primary={t.sideBar.manageCustomers}
              />
            </ListItemButton>

            {/* Manage Agents */}
            <ListItemButton
              className="lst-itm"
              selected={
                location.pathname === "/manage-vendors" ||
                location.pathname.startsWith("/manage-vendors/details") ||
                location.pathname.startsWith("/manage-reels/agents") ||
                location.pathname.startsWith("/manage-vendors/edit") ||
                location.pathname.startsWith("/manage-vendors/add") ||
                location.pathname.startsWith("/manage-vendors/edit/chat") ||
                location.pathname.startsWith("/manage-agent/token/details") ||
                location.pathname.startsWith(
                  "/manage-vendors/property/details"
                ) ||
                location.pathname.startsWith(
                  "/manage-vendors/property-listing/details"
                )
              }
              onClick={() => {
                navigate("/manage-vendors");
                setOpenMenu1(true);
              }}
            >
              <ListItemIcon
                ref={
                  isSelected?.includes("/manage-vendors") ? selectedRef : null
                }
              >
                <SupportAgentIcon />
              </ListItemIcon>
              <ListItemText
                className="lstitm-txt"
                primary={t.sideBar.manageVendors}
              />

              {agentCount && agentCount > 0 ? (
                <span className="badge">{agentCount || 0}</span>
              ) : null}
            </ListItemButton>
          </List>
        </Collapse>

        {/* Manage Categories */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-categories" ||
            location.pathname.startsWith("/manage-categories/details") ||
            location.pathname.startsWith("/manage-Subcategories/details") ||
            location.pathname.startsWith("/manage-Subcategories/edit") ||
            location.pathname.startsWith("/manage-categories/edit") ||
            location.pathname.startsWith("/manage-categories/add") ||
            location.pathname.startsWith("/manage-Subcategories/add") ||
            location.pathname.startsWith("/manage-categories-Main") ||
            location.pathname.startsWith("/manage-Subcategories/details") ||
            location.pathname.startsWith("/manage-categories/sub-categories")
          }
          onClick={() => navigate("/manage-categories")}
        >
          <ListItemIcon
            ref={
              isSelected?.includes("/manage-categories") ? selectedRef : null
            }
          >
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageCategories}
          />
        </ListItemButton>

        {/*<------------------ Manage Products=--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-products" ||
            location.pathname.startsWith("/manage-products/details") ||
            location.pathname.startsWith("/manage-products/edit") ||
            location.pathname.startsWith("/manage-products/add")
          }
          onClick={() => navigate("/manage-products")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-products") ? selectedRef : null}
          >
            <WidgetsIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageProducts}
          />
        </ListItemButton>
        {/*<------------------ Manage Products=--------------> */}
        {/*<------------------ Manage Quotes=--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-quotes" ||
            location.pathname.startsWith("/manage-quotes/details") ||
            location.pathname.startsWith("/manage-quotes/edit") ||
            location.pathname.startsWith("/manage-quotes/add")
          }
          onClick={() => navigate("/manage-quotes")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-quotes") ? selectedRef : null}
          >
            <FormatQuoteIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageQuotes}
          />
        </ListItemButton>
        {/*<------------------ Manage Quotes=--------------> */}

        {/*<------------------ Manage Banners--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-Banners" ||
            location.pathname.startsWith("/manage-Banners/details") ||
            location.pathname.startsWith("/manage-Banners/edit") ||
            location.pathname.startsWith("/manage-Banners/add") ||
            location.pathname.startsWith("/manage-Banners/add")
          }
          onClick={() => navigate("/manage-Banners")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-Banners") ? selectedRef : null}
          >
            <EmojiFlagsIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageBanners}
          />
        </ListItemButton>
        {/*<------------------ Manage Banners--------------> */}

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-discount" ||
            location.pathname.startsWith("/manage-discount/details") ||
            location.pathname.startsWith("/manage-discount/edit") ||
            location.pathname.startsWith("/manage-discount/add") ||
            location.pathname.startsWith("/manage-discount/add")
          }
          onClick={() => navigate("/manage-discount")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-discount") ? selectedRef : null}
          >
            <EmojiFlagsIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageDiscount}
          />
        </ListItemButton>
        {/*<------------------ Manage Orders--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-Order" ||
            location.pathname.startsWith("/manage-Order/details") ||
            location.pathname.startsWith("/manage-Order/edit") ||
            location.pathname.startsWith("/manage-Order/add")
          }
          onClick={() => navigate("/manage-Order")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-Order") ? selectedRef : null}
          >
            <LocalShippingIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageOrders}
          />
        </ListItemButton>
        {/*<------------------ Manage Orders--------------> */}
        {/*<------------------ Manage return exchange=--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-return-exchange" ||
            location.pathname.startsWith("/manage-return-exchange/details") ||
            location.pathname.startsWith("/manage-return-exchange/edit") ||
            location.pathname.startsWith("/manage-return-exchange/add")
          }
          onClick={() => navigate("/manage-return-exchange")}
        >
          <ListItemIcon
            ref={
              isSelected?.includes("/manage-return-exchange")
                ? selectedRef
                : null
            }
          >
            <CurrencyExchangeIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageReturnExchange}
          />
        </ListItemButton>
        {/*<------------------ Manage return exchange=--------------> */}

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-refunds"}
          onClick={() => navigate("/manage-refunds")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-refunds") ? selectedRef : null}
          >
            <CurrencyExchangeIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageRefunds}
          />
        </ListItemButton>

        {/*<------------------ Manage Chats--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-chats" ||
            location.pathname.startsWith("/manage-chats/details") ||
            location.pathname.startsWith("/manage-chats/edit") ||
            location.pathname.startsWith("/manage-chats/add")
          }
          onClick={() => navigate("/manage-chats")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-chats") ? selectedRef : null}
          >
            <ChatIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageChats}
          />
        </ListItemButton>
        {/*<------------------ Manage Chats--------------> */}
        {/*<------------------ Manage Payments--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-Payments" ||
            location.pathname.startsWith("/manage-Payments/details") ||
            location.pathname.startsWith("/manage-Payments/edit") ||
            location.pathname.startsWith("/manage-Payments/add")
          }
          onClick={() => navigate("/manage-Payments")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-Payments") ? selectedRef : null}
          >
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.managePayments}
          />
        </ListItemButton>
        {/*<------------------ Manage Payments--------------> */}
        {/*<------------------ Reporting Analytics--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/analytics"}
          onClick={() => navigate("/analytics")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/analytics") ? selectedRef : null}
          >
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary={t.sideBar.analytics} />
        </ListItemButton>
        {/*<------------------ Reporting Analytics--------------> */}

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-notifications" ||
            location.pathname.startsWith("/manage-notifications/add") ||
            location.pathname.startsWith("/recieved-notifications")
          }
          onClick={() => navigate("/manage-notifications")}
        >
          <ListItemIcon
            ref={
              isSelected?.includes("/manage-notifications") ? selectedRef : null
            }
          >
            <NotificationsActiveIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.notificationManagement}
          />
        </ListItemButton>
        {/*<------------------ Manage Sub Admin--------------> */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-subadmin" ||
            location.pathname.startsWith("/manage-subadmin/details") ||
            location.pathname.startsWith("/manage-subadmin/edit") ||
            location.pathname.startsWith("/manage-subadmin/add")
          }
          onClick={() => navigate("/manage-subadmin")}
        >
          <ListItemIcon
            ref={isSelected?.includes("/manage-subadmin") ? selectedRef : null}
          >
            <ReceiptIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary={t.sideBar.manageSubAdmin}
          />
        </ListItemButton>
        {/*<------------------ Manage Sub Admin--------------> */}
        {/*<------------------ Manage Customer/Vendor Support--------------> */}
        {/* <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-Customer-Vendor-Support" ||
            location.pathname.startsWith(
              "/manage-Customer-Vendor-Support/details"
            ) ||
            location.pathname.startsWith(
              "/manage-Customer-Vendor-Support/edit"
            ) ||
            location.pathname.startsWith("/manage-Customer-Vendor-Support/add")
          }
          onClick={() => navigate("/manage-Customer-Vendor-Support")}
        >
          <ListItemIcon
            ref={
              isSelected?.includes("/manage-Customer/Vendor Support")
                ? selectedRef
                : null
            }
          >
            <ReceiptIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Customer/Vendor Support"
          />
        </ListItemButton> */}
        {/*<------------------ Manage Customer/Vendor Support--------------> */}

        {/* Settings */}
        <ListItemButton
          className="lst-itm"
          onClick={() => {
            if (
              location.pathname === "/settings" ||
              location.pathname === "/manage-enqueries" ||
              location.pathname === "/manage-feedbacks" ||
              location.pathname === "/cms"
            )
              return;
            setOpenMenu3(!openMenu3);
          }}
          selected={
            location.pathname === "/settings" ||
            location.pathname === "/manage-enqueries" ||
            location.pathname === "/manage-feedbacks" ||
            location.pathname === "/cms"
          }
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary={t.sideBar.settings} />
          {openMenu3 ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse
          in={
            openMenu3 ||
            location.pathname === "/settings" ||
            location.pathname === "/manage-enqueries" ||
            location.pathname === "/manage-feedbacks" ||
            location.pathname === "/cms"
          }
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {/* General */}
            <ListItemButton
              className="lst-itm"
              selected={location.pathname === "/settings"}
              onClick={() => navigate("/settings")}
              ref={isSelected?.includes("/settings") ? selectedRef : null}
            >
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText
                className="lstitm-txt"
                primary={t.sideBar.general}
              />
            </ListItemButton>
            {/* Manage CMS */}
            <ListItemButton
              className="lst-itm"
              selected={location.pathname === "/cms"}
              onClick={() => navigate("/cms")}
              ref={isSelected?.includes("/cms") ? selectedRef : null}
            >
              <ListItemIcon>
                <SummarizeTwoToneIcon />
              </ListItemIcon>
              <ListItemText
                className="lstitm-txt"
                primary={t.sideBar.manageCms}
              />
            </ListItemButton>

            <ListItemButton
              className="lst-itm"
              selected={location.pathname === "/exchange-rate"}
              onClick={() => navigate("/exchange-rate")}
              ref={isSelected?.includes("/exchange-rate") ? selectedRef : null}
            >
              <ListItemIcon>
                <SummarizeTwoToneIcon />
              </ListItemIcon>
              <ListItemText
                className="lstitm-txt"
                primary={t.sideBar.conversionRate}
              />
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </>
  );

  useEffect(() => {
    if (selectedRef.current) {
      selectedRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
    setIsSelected(location.pathname);
  }, [isSelected]);

  return (
    <>
      <Box
        component="nav"
        sx={{ flexShrink: { lg: 0 } }}
        className="sidebar-main-div"
      >
        <Drawer
          className="sidebar_drawer"
          variant="temporary"
          open={mobileOpen}
          onClose={handleSidebarToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: SIDEBAR_WIDTH,
              right: 0,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          className="sidebar_drawer"
          sx={{
            display: { xs: "none", lg: "block" },
            "& .MuiDrawer-paper": {
              width: SIDEBAR_WIDTH,
              boxSizing: "border-box",
              right: 0,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
}

export default memo(Sidebar);
